<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-7">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                <td>
                  <flat-pickr @on-change="onChangeDate" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-5" >
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <b-table class="table-custom" @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" :current-page="currentPage">
<!--          <template slot="created_at" slot-scope="data">-->
          <template v-slot:cell(created_at)="data">
            {{parseDate(data.item.created_at)}}
          </template>
<!--          <template slot="member_id" slot-scope="data">-->
          <template v-slot:cell(member_id)="data">
            {{ data.item.member.branch ?  data.item.member.branch.codename : '' }}{{data.item.member.id}}
          </template>
<!--          <template slot="member_name" slot-scope="data">-->
          <template v-slot:cell(member_name)="data">
            {{data.item.member.first_name}} {{data.item.member.last_name}}
          </template>
<!--          <template slot="employee_id" slot-scope="data">-->
          <template v-slot:cell(employee_id)="data">
            <div v-if="data.item.sales">
              {{data.item.sales.employee_id}}
            </div>
            <div v-else>
              {{data.item.personal_training.id}}
            </div>
          </template>
<!--          <template slot="employee_name" slot-scope="data">-->
          <template v-slot:cell(employee_name)="data">
            <div v-if="data.item.sales">
              {{data.item.sales.fullname}}
            </div>
            <div v-else>
              {{data.item.personal_training.name}}
            </div>
          </template>
<!--          <template slot="product_sold" slot-scope="data">-->
          <template v-slot:cell(product_sold)="data">
            PT {{data.item.pt_session.name}} Tier-{{data.item.pt_session.pt_tier}}
          </template>
<!--          <template slot="gross" slot-scope="data">-->
          <template v-slot:cell(gross)="data">
              <template v-if="data.item.transaction_response">
                 Rp. {{parseCurrency(data.item.gross_amount + data.item.voucher_amount)}}
              </template>
              <template v-else>
                 Rp. {{parseCurrency(data.item.gross_amount)}}
              </template>
          </template>
<!--          <template slot="vat" slot-scope="data">-->
          <template v-slot:cell(vat)="data">
            <div v-if="data.item.transaction_detail">
              Rp. {{parseCurrency(data.item.transaction_detail.vat)}}
            </div>
          </template>
          <template v-slot:cell(voucher_amount)="data">
              Rp. {{parseCurrency(data.item.voucher_amount)}}
          </template>
<!--           <template slot="nett" slot-scope="data">-->
           <template v-slot:cell(nett)="data">
            <div v-if="data.item.transaction_detail">
              Rp. {{parseCurrency(data.item.transaction_detail.nett)}}
            </div>
          </template>
<!--          <template slot="status" slot-scope="data">-->
          <template v-slot:cell(status)="data">
            <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>

    <!-- loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'gallery',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'created_at',
          label: 'Date',
          sortable: true
        },
        {
          key: 'branch.name',
          label: 'Branch Name',
          sortable: true
        },
        {
          key: 'member_id',
          label: 'Member ID',
          sortable: false
        },
        {
          key: 'member_name',
          label: 'Member Name',
          sortable: false
        },
        {
          key: 'member.lead.leads_source_type.name',
          label: 'Lead Source',
          sortable: false
        },
        {
          key: 'member.phone_number',
          label: 'Phone Number',
          sortable: false
        },
        {
          key: 'employee_id',
          label: 'Employee ID',
          sortable: false
        },
        {
          key: 'employee_name',
          label: 'Session Sold By',
          sortable: false
        },
        {
          key: 'personal_training.name',
          label: 'Personal Trainer',
          sortable: false
        },
        {
          key: 'session_contract_category.name',
          label: 'Session Category',
          sortable: false
        },
        {
          key: 'product_sold',
          label: 'Product Sold',
          sortable: false
        },
        {
          key: 'or_number',
          label: 'OR Number',
          sortable: false
        },
        {
          key: 'session_payment_type.name',
          label: 'Payment Type',
          sortable: false
        },
        {
          key: 'payment_type_1.name',
          label: 'Payment by',
          sortable: false
        },
        {
          key: 'gross',
          label: 'Gross (IDR)',
          sortable: false
        },
        {
          key: 'total_payment',
          label: 'Total Payment (IDR)',
          sortable: false,
          formatter: (value, key, item) => {
            return 'Rp. ' + parseInt(item.gross_amount).toLocaleString('id-ID', {maximumFractionDigits:0})
          }
        },
        {
          key: 'vat',
          label: 'VAT (IDR)',
          sortable: false
        },
        {
          key: 'voucher_amount',
          label: 'Voucher (IDR)',
          sortable: false
        },
        {
          key: 'nett',
          label: 'NETT (IDR)',
          sortable: false
        },
        {
          key: 'pt_session.quantity',
          label: 'SS',
          sortable: false
        },
        {
          key: 'pt_session.mbg_tier',
          label: 'MBG Tier',
          sortable: false
        },
        {
          key: 'pt_session.price_normal',
          label: 'Normal Price (IDR)',
          sortable: false,
          formatter: (value, key, item) => {
            return item.pt_session.price_normal == null ? 'Rp. 0' : 'Rp. ' + parseInt(item.pt_session.price_normal).toLocaleString('id-ID', {maximumFractionDigits:0})
          }
        },
        {
          key: 'member_pt_session.expired_at',
          label: 'Expired',
          sortable: false,
          formatter: (value, key, item) => {
            return moment(item.member_pt_session.expired_at).format('DD MMMM YYYY')
          }
        },
        {
          key: 'notes',
          label: 'Notes',
          sortable: false
        }
      ],
      items: [],
      dataBranch: [],
      branch_id: null,
      getRoleId: Auth.Session.get().paradigm_role,
      getID: Auth.Session.get().paradigm_id,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))],
        // onChange: this.onChange
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    onChangeDate(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    parseCurrency(value) {
      // var newValue = value.toFixed()
      return value.toLocaleString('id-ID', {maximumFractionDigits:0})
    },
    openPage (event) {
      this.$router.push(event)
    },
    editGallery (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    parseDate(value) {
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'compro/v1/img/gallery/' + value
    },
    exportReport() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/pt_report/log?start='+dates[0]+'&end='+dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      if (Auth.Session.get().paradigm_role == 7) {
        url += '&personal_trainer_id=' + this.getID
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'PT Log (Report) '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    changeBranch(event) {
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/pt_report/log?page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData
      + '&start=' + dates1[0]
      + '&end=' + dates1[1]

      if (event != null) {
        url += '&branch_id=' + event
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      this.loadingActive = true
      let dates1 = this.exportDates.split(' to ')
      dates1[1] = dates1[1] == undefined ? dates1[0] : dates1[1]
      if(Auth.Session.get().paradigm_role == 7){
        axios.get('crm/v1/pt_report/log?personal_trainer_id=' + Auth.Session.get().paradigm_id
          +'&page=' + this.currentPage
          + '&limit=' + this.paginationLimit
          + '&sorting=' + this.sortBy
          + '&sorting_type=' + this.sortType
          + '&keyword=' + this.searchData
          + '&start=' + dates1[0]
          + '&end=' + dates1[1]).then(response => {
          this.loadingActive = false
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
        }).catch(error => {
          this.loadingActive = false
          console.log('error', error)
        })
      } else {
        let url = 'crm/v1/pt_report/log?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start=' + dates1[0]
        + '&end=' + dates1[1]

        if (this.branch_id != null) {
          url += '&branch_id=' + this.branch_id
        }

        axios.get(url).then(response => {
          this.loadingActive = false
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
        }).catch(error => {
          this.loadingActive = false
          console.log('error', error)
        })

        axios.get('fitness/v1/branch/').then(response => {
          this.dataBranch = response.data.data.rows
        }).catch(error => {
          console.log('error', error)
        })
      }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
